import { MailOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@Components/Modal';
import SMTPSettingsVerificationModalProps from '@Components/SMTPSettingsVerificationModal/SMTPSettingsVerificationModal.types';

const SMTPSettingsVerificationModal: FunctionComponent<SMTPSettingsVerificationModalProps> =
  (props: SMTPSettingsVerificationModalProps): JSX.Element => {
    const { t } = useTranslation();

    const { isModalOpen, setIsModalOpen, email, onClick } = props;

    const handleModalClose = () => {
      setIsModalOpen(false);
    };

    return (
      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        headerText={t('SMTP.verificationModal.headerText')}
      >
        <Box
          position="relative"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '24px',
            marginBottom: '74px',
          }}
        >
          <MailOutlined
            sx={{
              color: '#767676',
              marginBottom: '12px',
              height: '50px',
              width: '40px',
            }}
          />
          <Typography
            component="h2"
            fontWeight="bold"
            fontSize="24px"
            lineHeight="33px"
            color="#767676"
          >
            {t('SMTP.verificationModal.Verify Your Email Address')}
          </Typography>
          <Typography
            fontWeight="400"
            sx={{ width: '432px', textAlign: 'center', marginBottom: '16px' }}
          >
            We have sent an email to{' '}
            <Typography component="span" fontWeight="bold">
              {email}
            </Typography>{' '}
            with a verification link to confirm the validity of your email
            address. Please check your inbox and confirm your email address.
          </Typography>
          <Typography>
            {t('SMTP.verificationModal.Haven`t received email')}{' '}
            <Typography
              component="span"
              sx={{ color: '#0045B9', cursor: 'pointer' }}
              onClick={onClick}
            >
              {t('SMTP.verificationModal.Send again')}
            </Typography>
          </Typography>
        </Box>
      </Modal>
    );
  };

export default SMTPSettingsVerificationModal;
